// Tiny module-level pointer to the currently authenticated user's id so
// non-React code (like the top-level ErrorBoundary) can attribute crash reports
// without pulling in AuthContext.

let currentUserId = null;

export const setCurrentUserId = (id) => {
  currentUserId = id || null;
};

export const getCurrentUserId = () => currentUserId;
